import Downshift from 'downshift';
import type { DownshiftProps } from 'downshift';
import type { OptionType } from '@withjoy/joykit';

type StateReducerProps<T extends OptionType> = Readonly<{
  options: ReadonlyArray<T>;
  value?: T | null;
}>;

export const createLocationInputV2StateReducerHandler = <T extends OptionType>(getProps: () => StateReducerProps<T>): DownshiftProps<T>['stateReducer'] => {
  return (state, changes) => {
    const { value, options } = getProps();

    switch (changes.type) {
      case Downshift.stateChangeTypes.blurInput:
        return { ...changes, inputValue: state.inputValue };
      case Downshift.stateChangeTypes.keyDownEnter:
      case Downshift.stateChangeTypes.clickItem: {
        if (value !== undefined) {
          return { ...state };
        }
        return {
          ...changes,
          highlightedIndex: changes.selectedItem ? options.indexOf(changes.selectedItem) : null,
        };
      }
      default:
        return changes;
    }
  };
};
